import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './reducer';

export const selectUser = createFeatureSelector<AuthState>('auth');

export const selectUserData = createSelector(
	selectUser,
	(state) => state && state.userData,
);
